export class Set {
    public id: string;
    public name: string;
    public description: string;

    constructor(name: string, description: string, index: number, id?: string) {
        this.id = id ?? index.toString(); // V budoucnu by bylo dobré zavést id sady i v xml-ku
        this.name = name;
        this.description = description;
    }
}
